import React from 'react'
import AnsQandAUserAll from '../ansuser/AnsQandAUserAll';
import MenuDoctor from './navDoctor/MenuDoctor'
function AnsMedical() {
    return (
        <div className='global-page'>
            <MenuDoctor menuActive={'ans'} />
            <AnsQandAUserAll roleUser={'Medical'}/>
        </div>
    )
}

export default AnsMedical